import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { Subject } from "rxjs";
import { SpinnerService } from 'shared-components';
import { AdminService } from '../../../services/admin.service';

@Component({
    selector: 'app-auditores-entidad',
    templateUrl: './auditores.component.html'
})
export class AuditoresEntidadControlComponent implements OnInit {

    private readonly _DEFAULT_ITEMS_PER_PAGE = 5;

    public auditores;

    public itemsPerPage = this._DEFAULT_ITEMS_PER_PAGE;
    public currentPage = 0;
    public totalItems: number;
    public readonly visiblePages = 3;

    @Input() entidadControl;

    constructor(
        private readonly _spinnerService: SpinnerService,
        private readonly _adminService: AdminService
    ) {}

    ngOnInit() {
        this.getDesignacionesFinca();
    }

    public pageChange(page) {
        this.currentPage = page - 1;
        this.getDesignacionesFinca();
    }


    public getDesignacionesFinca() {
        let filters = {
            numPagina: this.currentPage,
            tamPagina: this.itemsPerPage,
            entidadControlId: this.entidadControl.id
        }
        this._spinnerService.showSpinner();
        this._adminService.getAuditores(filters).toPromise().finally(() => {
            this._spinnerService.hideSpinner();
        }).then((resp) => {
            this.totalItems = resp.paginacionMeta.totalCount;
            this.auditores = resp.lista;
        });
    }
}
